// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroPanel_root__32Nqs","questionTitle":"IntroPanel_questionTitle__3K_8x","answerTitle":"IntroPanel_answerTitle___wli8","subtitle":"IntroPanel_subtitle__3VZ6R"};